
    import { defineComponent, SetupContext } from 'vue'
    import useStore from '@/hooks/useStore'
    import { StoreState } from '@/store'

    import Wizard from '@/components/Wizard/SteepHome.vue'

    interface SetupReturn {
        emit: SetupContext['emit']
        store: StoreState
    }

    export default defineComponent({
        components: {
            Wizard
        },

        emits: ['close-box'],

        setup (_, { emit }: SetupContext): SetupReturn {
            const store = useStore()

            return {
                store,
                emit
            }
        }
    })
